import React, { useMemo } from 'react';
import { StylesCustomizer } from '@srcDS/components/molecules/stylesCustomizer';
import styles from '@srcDS/components/atoms/countdown/Countdown.module.scss';

import { Text } from '../../../typography/text/Text';

const NumberText = (variables) => (
  <Text className={styles.countStringNumber} as="p" variables={variables} weight="normal">
    <span dangerouslySetInnerHTML={{ __html: variables.text }} />
  </Text>
);

export const useTimeFormatter = (viewAsString, countTextStyles) => {
  const textFormat = useMemo(
    () => ({
      days: 'days',
      hours: viewAsString ? 'hrs' : 'hours',
      minutes: viewAsString ? 'mins' : 'minutes',
      seconds: viewAsString ? 'secs' : 'seconds',
    }),
    [viewAsString],
  );

  const StyledNumber = useMemo(() => StylesCustomizer(NumberText), []);

  // Format time display based on view mode
  const formatTime = (time, additional) => {
    if (viewAsString) {
      const timeByChars = time?.toString().padStart(2, '0');
      /*@ts-ignore*/
      return <StyledNumber styles={countTextStyles} text={`${timeByChars} ${additional}`}></StyledNumber>;
    }

    const timeByChars = time?.toString().padStart(2, '0').split('');
    return (
      <>
        <span className={styles.countNumbers}>
          {timeByChars?.map((item, index) => (
            <span key={`${additional}-${index}`} className={styles.countItem}>
              {item}
            </span>
          ))}
        </span>
        <p className={styles.countText}>{additional}</p>
      </>
    );
  };

  return { formatTime, textFormat };
};
